import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@awaze/design-system.components.stack';
import { Container } from '@awaze/design-system.components.container';
import { Box } from '@awaze/design-system.components.box';
import { FooterPanels } from './footer-panels';
import { FooterMenu } from './footer-menu';
import { FooterSocialLinks } from './footer-social-links';
import { FooterTerms } from './footer-terms';
import { StyledDivider, StyledFooter } from './footer.styles';
/**
 * This composition is for rendering a branded footer.
 *
 * This component currently includes a hard coded design token brand abstraction layer called footerConfig.
 *
 * This will be replaced once we build a new design token abstraction layer.
 */
export const Footer = ({ labels, styleProps, locationSelect, }) => {
    return (_jsx(StyledFooter, { children: _jsx(Box, { padding: [
                [0, 0, 0, 0],
                [48, 16, 48, 16],
                [48, 16, 48, 16],
            ], children: _jsxs(Container, { children: [_jsxs(Stack, { direction: "column", spacing: 20, children: [_jsx(FooterPanels, { panels: labels.panels }), _jsx(Box, { padding: [
                                    [0, 16, 0, 16],
                                    [0, 0, 0, 0],
                                    [0, 0, 0, 0],
                                ], children: _jsx(FooterMenu, { menu: labels.menu, theme: styleProps?.accordion?.theme }) })] }), _jsx(Box, { padding: [22, 0, 0], children: _jsx(StyledDivider, { colourScheme: "light" }) }), _jsx(Box, { padding: [
                            [0, 16, 48, 16],
                            [0, 0, 0, 0],
                            [0, 0, 0, 0],
                        ], children: _jsxs(Stack, { direction: "column", spacing: 16, children: [_jsx(FooterSocialLinks, { socialLinks: labels.socialMediaIcons, styles: styleProps?.socialLinks, locationSelect: locationSelect }), _jsx(FooterTerms, { companyInformation: labels.companyInformation, termsAndConditions: labels.termsAndConditions })] }) })] }) }) }));
};
//# sourceMappingURL=footer.js.map